export const authApi = {
	/**
	 * Initiate login flow via redirect (Legacy Adapter)
	 * @param provider - OAuth provider ('google' | 'microsoft' | 'github')
	 * @param redirectUri - Relative redirect URI
	 */
	initiateLogin: (provider: 'google' | 'microsoft' | 'github', redirectUri: string): void => {
		// Legacy behavior: redirect to /oauth2/{provider}
		// Attempting to pass redirect_uri as a query param, though legacy might rely on session/cookie
		window.location.href = `/oauth2/${provider}?redirect_uri=${encodeURIComponent(redirectUri)}`
	},

	logout: (): void => {
		localStorage.removeItem('auth-storage')
		sessionStorage.clear()
		window.location.href = '/logout'
	},
}
